var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { TestPositionColor } from '../Common/colors';
import { getColorByStatus } from './Day';
var getColorByName = function (color) {
    switch (color) {
        case 'pink':
            return TestPositionColor.FAR_BELOW;
        case 'yellow':
            return TestPositionColor.BELOW;
        case 'green':
            return TestPositionColor.MEETS;
        case 'dark-green':
            return TestPositionColor.EXCEEDS;
        default:
            return TestPositionColor.FAR_BELOW;
    }
};
var Color = styled.span.withConfig({ displayName: "Color", componentId: "sc-1rhpmmw" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 8px;\n  height: 8px;\n\n  position: relative;\n  top: -1px;\n\n  display: inline-block;\n\n  margin-right: 4px;\n\n  border-radius: 100%;\n  background: ", ";\n"], ["\n  width: 8px;\n  height: 8px;\n\n  position: relative;\n  top: -1px;\n\n  display: inline-block;\n\n  margin-right: 4px;\n\n  border-radius: 100%;\n  background: ", ";\n"])), function (_a) {
    var _b = _a.color, color = _b === void 0 ? '' : _b;
    return getColorByName(color);
});
var Description = styled.div.withConfig({ displayName: "Description", componentId: "sc-dgvzcv" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  min-width: 265px;\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  &:not(:last-child) {\n    margin-bottom: 4px;\n  }\n"], ["\n  min-width: 265px;\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  &:not(:last-child) {\n    margin-bottom: 4px;\n  }\n"])));
var Text = styled.p.withConfig({ displayName: "Text", componentId: "sc-19si6w7" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n\n  font-family: var(--main-font);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n"], ["\n  margin: 0;\n\n  font-family: var(--main-font);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n"])));
var Status = styled.p.withConfig({ displayName: "Status", componentId: "sc-19crfda" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-bottom: 0;\n  margin-left: auto;\n\n  font-family: var(--main-font);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: right;\n  color: ", ";\n"], ["\n  margin-bottom: 0;\n  margin-left: auto;\n\n  font-family: var(--main-font);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: right;\n  color: ", ";\n"])), function (_a) {
    var status = _a.status;
    return getColorByStatus(status);
});
var Score = function (_a) {
    var assessment = _a.assessment, _b = _a.shouldShowResult, shouldShowResult = _b === void 0 ? false : _b, rest = __rest(_a, ["assessment", "shouldShowResult"]);
    var color = assessment.color, growth = assessment.growth, position = assessment.position, quantile = assessment.quantile, status = assessment.status;
    var isInProgress = status === 'in_progress';
    var hasCanceledBeforeResult = status === 'canceled' && quantile === null;
    var hasScore = quantile != null;
    var hasGrowth = growth != null;
    var withSetScore = (_jsxs(_Fragment, { children: [!isInProgress ? _jsx(Color, { color: color }, void 0) : 'TBD', hasScore && quantile + " ", hasGrowth && "(" + (growth > 0 ? '+' : '') + growth + ") ", hasScore && '| ', !isInProgress && (position === null || position === void 0 ? void 0 : position.replace('_', ' '))] }, void 0));
    return (_jsxs(Description, __assign({}, rest, { children: [_jsxs(Text, { children: ["Score: ", hasCanceledBeforeResult ? 'n/a' : withSetScore] }, void 0), shouldShowResult && _jsx(Status, __assign({ status: status }, { children: status }), void 0)] }), void 0));
};
var Placed = function (_a) {
    var assessment = _a.assessment;
    var status = assessment.status, quantile = assessment.quantile, type = assessment.type, placedTo = assessment.placed_to;
    var hasCanceledBeforeResult = status === 'canceled' && quantile === null;
    var position = hasCanceledBeforeResult ? 'n/a' : placedTo !== null && placedTo !== void 0 ? placedTo : 'TBD';
    if (type === 'finally')
        return null;
    return (_jsx(Description, { children: _jsxs(Text, { children: [type === 'middle' ? 'Replaced' : 'Placed', " to: ", position] }, void 0) }, void 0));
};
export { Score, Placed, Status };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
